<template>
    <div class="mt-5">
        <label v-if="address !== ''" for="zip_code" class="font-medium">Please enter the zip code associated with your address:</label>
        <label v-else for="zip_code" class="font-medium">Please enter your zip code:</label>
        <p v-if="false && address !== ''" class="font-medium text-center p-2 pb-1">{{ address }}</p>
        <input :value="zipCode" @input="$emit('update:zip', $event.target.value)" @keydown.enter="$emit('submit')" type="text" name="zip_code" id="zip_code" :class="`mt-2 bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`" placeholder="Enter Zip Code">
    </div>
</template>

<script>
    export default {
        props: ['zip', 'address'],

        computed: {
            zipCode() {
                return this.zip;
            }
        }
    }
</script>